'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _HS_SHARE_URL_TYPES;

var HS_FORMS_DOMAIN = 'hsforms';
var HS_DOMAINS = {
  hsforms: {
    prod: 'hsforms.com',
    qa: 'hsformsqa.com'
  }
};
export var SHARE_URL_TYPE = 'share';
export var SURVEY_URL_TYPE = 'survey';
export var HS_SHARE_URL_TYPES = (_HS_SHARE_URL_TYPES = {}, _defineProperty(_HS_SHARE_URL_TYPES, SHARE_URL_TYPE, 'share'), _defineProperty(_HS_SHARE_URL_TYPES, SURVEY_URL_TYPE, 'survey'), _HS_SHARE_URL_TYPES);
export var getHubletSuffix = function getHubletSuffix(hublet) {
  return hublet && hublet !== 'na1' ? "-" + hublet : '';
};
export var getDomainEnv = function getDomainEnv(env) {
  return env === 'local' || env === 'qa' ? 'qa' : 'prod';
};
export var getSubdomain = function getSubdomain(shareType) {
  return HS_SHARE_URL_TYPES[shareType];
};
export var getDomain = function getDomain(domain, env) {
  return HS_DOMAINS[domain][getDomainEnv(env)];
};
export var getShareableUrl = function getShareableUrl(sharableUrlType) {
  var customOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = Object.assign({
    hublet: '',
    isQA: false
  }, customOptions);
  var env = options.isQA ? 'qa' : '';
  var subdomain = getSubdomain(sharableUrlType);
  var hubletSuffix = getHubletSuffix(options.hublet);
  var domain = getDomain(HS_FORMS_DOMAIN, env);
  return "https://" + subdomain + hubletSuffix + "." + domain;
};